export const environment = {
  production: true,

  // PRODUZIONE - Opzione B
  apiURL: 'https://api.backoffice.meloni.sm/api/',
  apiURLrestApiService: 'https://rest-api-service.mcdatasolution.net/api/',
  apiURLAlternative: 'https://api.backoffice.meloni.sm/api/',
  apiVersion: 'v1/',

  // Storage Configuration
  storageURL: 'https://piucardstorage.blob.core.windows.net/container/',

  // Documentation Server
  documentationBaseURL: 'https://api.backoffice.meloni.sm/',

  // Documentation Files
  documents: {
    promoDocumentation: 'pdf/Documentazione_Promo.pdf',
    categorieDocumentation: 'pdf/Documentazione_Categorie_Promo.pdf',
    volantiniDocumentation: 'pdf/Documentazione_Volantini.pdf',
    buoniValoreChecklist: 'pdf/CHECKLIST_Coupon.pdf',
    loghiDocumentation: 'pdf/Documentazione_Gestione_loghi.pdf',
    promoscortaDocumentation: 'pdf/Documentazione_SMIT_Promo_scorta.pdf',
    notificheAppDocumentation: 'pdf/Documentazione_Notifiche_App.pdf',
    promoDettaglioDocumentation: 'pdf/Documentazione_nuova_gestione_bollini.pdf',
    promoCouponDocumentation: 'pdf/Documentazione_Creazione_Coupon.pdf'
  },

  // Excel Templates
  excelTemplates: {
    promoScorta: 'excel/Modello_Promo_Scorta.xlsx',
    contingentati: 'excel/Modello_Contingentati.xlsx'
  },

  // BMP Images
  bmpBaseURL: 'https://api.backoffice.meloni.sm/bmp_Talloncini/',
  bmpImages: {
    primo: 'primo.bmp',
    secondo: 'secondo.bmp'
  },

  // File Paths
  filePaths: {
    helpFiles: 'https://api.backoffice.meloni.sm/file/'
  }
};